import gql from 'graphql-tag';

export const query = gql`
  query Notes($input: ApplicationNotesInput!) {
    applicationNotesV2(input: $input) {
      ... on ApplicationNotesResponseSuccess {
        result {
          id
          createdUserFirstname
          createdUserLastname
          createdUserId
          content
          createdDate
        }
      }
      ... on ResponseError {
        error
      }
    }
  }
`;
